/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { Hook } from './Hook.js';
import {
    HookFromJSON,
    HookFromJSONTyped,
    HookToJSON,
} from './Hook.js';

/**
 * 
 * @export
 * @interface SingleHookResponse
 */
export interface SingleHookResponse {
    /**
     * 
     * @type {Hook}
     * @memberof SingleHookResponse
     */
    data?: Hook;
    /**
     * 
     * @type {number}
     * @memberof SingleHookResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof SingleHookResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof SingleHookResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof SingleHookResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the SingleHookResponse interface.
 */
export function instanceOfSingleHookResponse(value: object): boolean {
    return true;
}

export function SingleHookResponseFromJSON(json: any): SingleHookResponse {
    return SingleHookResponseFromJSONTyped(json, false);
}

export function SingleHookResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SingleHookResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : HookFromJSON(json['data']),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function SingleHookResponseToJSON(value?: SingleHookResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': HookToJSON(value['data']),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

